import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-numeric-input',
  templateUrl: './numeric-input.component.html'
})
export class NumericInputComponent implements OnInit {
  formElement!: FormGroup;
  inputNgModelNojs: string = '';
  submitted: boolean = false;
  isBrowser: boolean = true;
  paramsSubscription!: Subscription;
  minVal: number = 0 as number;
  maxVal: number = 10 as number;

  constructor(
    private formBuilder: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }

  ngOnInit(): void {
    this.formElement = this.formBuilder.group({
      inputNumber: ['', [Validators.required, this.minValidator]],
      inputNumber2: ['', [Validators.required, this.minValidator]],
      formId:['', [Validators.required, this.minValidator]]

    });

    this.paramsSubscription = this._activatedRoute.queryParams.subscribe(param => {
      if (param['noJsInput']) {
        this.inputNgModelNojs = param['noJsInput'];
      }
    });
  }

  minValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (parseInt(control.value) < this.minVal || parseInt(control.value) > this.maxVal) {
      return { minError: true };
    }
    if (isNaN(control.value)) {
      return { onlyNumberError: true };
    }
    return null;
  };

  ngOnDestroy(): void {
    if(this.isBrowser){
      this.paramsSubscription.unsubscribe();
    }
  }

  onSubmit() {
    this.submitted = true;
  }
}